import { Action, createReducer, on } from '@ngrx/store';
import { IUtilitiesState } from './utilities';
import {
  RETRIEVE_UTILITY_LDV_SUCCESS,
  RETRIEVE_GESTIONE_UTENZE_SUCCESS,
  UPLOAD_DOCUMENT_LDV_SUCCESS,
  CREATE_UTENZA_SUCCESS,
  RETRIEVE_LISTA_RETE_TERZE_SUCCESS,
  RETRIEVE_COMPENSI_RETE_SUCCESS,
  RETRIEVE_RETE_TERZA_LIST_SUCCESS,
  RETRIEVE_COMPENSI_RETE_POST_SUCCESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_SUCCESS,
  RETRIEVE_CONFIGURAZIONE_BOXLESS_POST_SUCCESS,
  RETRIEVE_NEARLIST_UFF_POSTALE_SUCCESS,
  RETRIEVE_FRAZ_SUCCESS,
  RETRIEVE_CD_GO_SUCCESS,
  RETRIEVE_GO_SUCCESS,
  RETRIEVE_RAM_GO_SUCCESS,
  SEARCH_LISTA_RECAPITO_SUCCESS,
  RETRIEVE_RECAPITO_SUCCESS,
  RETRIEVE_LISTA_CATALOGO_MATERIALE_SUCCESS,
  RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO_SUCCESS,
  RETRIEVE_REGOLE_ORDINE_SUCCESS,
  RETRIEVE_LISTA_CLUSTER_SUCCESS,
  RETRIEVE_ORDER_HISTORY_SUCCESS,
  RETRIEVE_STORICO_ORDINI_PROFILI_SUCCESS,
  RETRIEVE_STORICO_ORDINI_PARTNER_SUCCESS,
  RETRIEVE_CREATE_ORDER_SUCCESS,
  RETRIVE_LISTA_FRAZIONARIO_SUCCESS,
  RESET_UTILITY_STORE,
  RETRIEVE_PIN_RECOVERY_SUCCESS,
} from './utilities.actions';
import { RetrieveUtilityLdv } from '../../interfaces/retrieve-utility-ldv';
import {
  IResponseGestioneUtenze,
  IResponseCreazioneUtenza,
} from '../../interfaces/gestione-utenze';
import {
  IResponseCompensiRete,
  IResponseCompensiRetePost,
} from '../../interfaces/compensi';
import { ResponseAnagraphicManagement } from '../../interfaces/response-anagraphic-management';
import { IResponseListaReteTerze } from '../../interfaces/utility-report-punto-poste';
import { IConfigurazioneBoxless } from '../../interfaces/configurazione-boxless';
import { ResponseNearlistUffPostale } from '../../interfaces/nearlist';
import { ResponseCercaPerStrutturaRecapito } from '../../interfaces/cerca-per-struttura-recapito';
import {
  IResponseGo,
  IResponseRamGo,
  IResponseCdGo,
  IResponseFraz,
  IResponseRecapito,
} from '../../interfaces/go';
import { IResponseListaCatalogoMateriale } from '../../interfaces/catalogo-materiale';
import { IResponseCluster } from '../../interfaces/cluster';
import {
  IResponseConfigurazioneApprovvigionamento,
  IResponseOrdiniApprovvigionamento,
} from '../../interfaces/configurazione-approvvigionamento';
import { IResponseRegoleOrdine } from '../../interfaces/regole-ordine';
import { ResponseOrderHistory } from '../../interfaces/response-order-history';
import { ResponseCreazioneOrdine } from '../../interfaces/response-creazione-ordine';
import { IResponsePinRecovery } from '../../interfaces/pin-recovery';
import { IResponseStoricoOrdiniPartner, IResponseStoricoOrdiniProfili } from '../../interfaces/storico-ordini-filter-options';

/* INITIAL STATE */
const initialState: IUtilitiesState = {
  responseUtilityLdv: null,
  responseDocumentoLdv: null,
  responseGestioneUtenze: null,
  responseCercaRecapito: null,
  responseGo: null,
  responseRamGo: null,
  responseCdGo: null,
  responseFraz: null,
  responseRecapito: null,
  responseListaCatalogoMateriale: null,
  responseListaCluster: null,
  responseConfigurazioneApprovvigionamento: null,
  responseRegoleOrdine: null,
  responseStoricoOrdini: null,
  responseStoricoOrdiniProfili: null,
  responseStoricoOrdiniPartner: null,
  responseCreazioneOrdine: null,
  responseListFrazionario: null,
  responsePinRecovery: null
};

const handleSaveUtilityLdv = (
  state: IUtilitiesState,
  { responseUtilityLdv }: { responseUtilityLdv: RetrieveUtilityLdv | null }
): IUtilitiesState => {
  return {
    ...state,
    responseUtilityLdv,
  };
};
const handleSearchStrutturaRecapito = (
  state: IUtilitiesState,
  {
    responseCercaRecapito,
  }: { responseCercaRecapito: ResponseCercaPerStrutturaRecapito | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCercaRecapito,
  };
};

const handleGestioneUtenze = (
  state: IUtilitiesState,
  {
    responseGestioneUtenze,
  }: { responseGestioneUtenze: IResponseGestioneUtenze | null }
): IUtilitiesState => {
  return {
    ...state,
    responseGestioneUtenze,
  };
};

const handleCreazioneUtenza = (
  state: IUtilitiesState,
  {
    responseCreazioneUtenza,
  }: { responseCreazioneUtenza: IResponseCreazioneUtenza | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCreazioneUtenza,
  };
};

const handleListaReteTerze = (
  state: IUtilitiesState,
  {
    responseListaReteTerze,
  }: { responseListaReteTerze: IResponseListaReteTerze | null }
): IUtilitiesState => {
  return {
    ...state,
    responseListaReteTerze,
  };
};

const handleDocumentLdv = (
  state: IUtilitiesState,
  { responseDocumentoLdv }: { responseDocumentoLdv: { esito: string } | null }
): IUtilitiesState => {
  return {
    ...state,
    responseDocumentoLdv,
  };
};

const handleReteTerzaList = (
  state: IUtilitiesState,
  {
    responseReteTerzaList,
  }: { responseReteTerzaList: ResponseAnagraphicManagement | null }
): IUtilitiesState => {
  return {
    ...state,
    responseReteTerzaList,
  };
};

const handleResponseCompensiRete = (
  state: IUtilitiesState,
  {
    responseCompensiRete,
  }: { responseCompensiRete: IResponseCompensiRete | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCompensiRete,
  };
};

const handleResponseCompensiRetePost = (
  state: IUtilitiesState,
  {
    responseCompensiRetePost,
  }: { responseCompensiRetePost: IResponseCompensiRetePost | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCompensiRetePost,
  };
};

const handleResponseConfigurazioneBoxless = (
  state: IUtilitiesState,
  {
    responseConfigurazioneBoxless,
  }: { responseConfigurazioneBoxless: IConfigurazioneBoxless | null }
): IUtilitiesState => {
  return {
    ...state,
    responseConfigurazioneBoxless,
  };
};

const handleResponseConfigurazioneBoxlessPost = (
  state: IUtilitiesState,
  {
    responseConfigurazioneBoxlessPost,
  }: { responseConfigurazioneBoxlessPost: IConfigurazioneBoxless | null }
): IUtilitiesState => {
  return {
    ...state,
    responseConfigurazioneBoxlessPost,
  };
};

const handleResponseFrazionarioList = (
  state: IUtilitiesState,
  {
    responseNearlistUffPostale,
  }: { responseNearlistUffPostale: ResponseNearlistUffPostale | null }
): IUtilitiesState => {
  return {
    ...state,
    responseNearlistUffPostale,
  };
};

const handleResponseGo = (
  state: IUtilitiesState,
  { responseGo }: { responseGo: IResponseGo | null }
): IUtilitiesState => {
  return {
    ...state,
    responseGo,
  };
};

const handleResponseRamGo = (
  state: IUtilitiesState,
  { responseRamGo }: { responseRamGo: IResponseRamGo | null }
): IUtilitiesState => {
  return {
    ...state,
    responseRamGo,
  };
};

const handleResponseCdGo = (
  state: IUtilitiesState,
  { responseCdGo }: { responseCdGo: IResponseCdGo | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCdGo,
  };
};

const handleResponseFraz = (
  state: IUtilitiesState,
  { responseFraz }: { responseFraz: IResponseFraz | null }
): IUtilitiesState => {
  return {
    ...state,
    responseFraz,
  };
};

const handleResponseRecapito = (
  state: IUtilitiesState,
  { responseRecapito }: { responseRecapito: IResponseRecapito | null }
): IUtilitiesState => {
  return {
    ...state,
    responseRecapito,
  };
};

const handleResponseListaCatalogoMateriale = (
  state: IUtilitiesState,
  {
    responseListaCatalogoMateriale,
  }: { responseListaCatalogoMateriale: IResponseListaCatalogoMateriale | null }
): IUtilitiesState => {
  return {
    ...state,
    responseListaCatalogoMateriale,
  };
};

const handleResponseListaCluster = (
  state: IUtilitiesState,
  { responseListaCluster }: { responseListaCluster: IResponseCluster | null }
): IUtilitiesState => {
  return {
    ...state,
    responseListaCluster,
  };
};

const handleResetUtilityStore = (): IUtilitiesState => {
  return {
    responseUtilityLdv: null,
    responseDocumentoLdv: null,
    responseGestioneUtenze: null,
    responseCercaRecapito: null,
    responseGo: null,
    responseRamGo: null,
    responseCdGo: null,
    responseFraz: null,
    responseRecapito: null,
    responseListaCatalogoMateriale: null,
    responseListaCluster: null,
    responseConfigurazioneApprovvigionamento: null,
    responseRegoleOrdine: null,
    responseStoricoOrdini: null,
    responseStoricoOrdiniProfili: null,
    responseStoricoOrdiniPartner: null,
    responseCreazioneOrdine: null,
    responseListFrazionario: null,
    responsePinRecovery: null
  };
};

const handleResponseConfigurazioneApprovvigionamento = (
  state: IUtilitiesState,
  {
    responseConfigurazioneApprovvigionamento,
  }: {
    responseConfigurazioneApprovvigionamento: IResponseConfigurazioneApprovvigionamento | null;
  }
): IUtilitiesState => {
  return {
    ...state,
    responseConfigurazioneApprovvigionamento,
  };
};

const handleResponseRegoleOrdine = (
  state: IUtilitiesState,
  {
    responseRegoleOrdine,
  }: { responseRegoleOrdine: IResponseRegoleOrdine | null }
): IUtilitiesState => {
  return {
    ...state,
    responseRegoleOrdine,
  };
};

const handleResponseStoricoOrdini = (
  state: IUtilitiesState,
  {
    responseStoricoOrdini,
  }: { responseStoricoOrdini: ResponseOrderHistory | null }
): IUtilitiesState => {
  return {
    ...state,
    responseStoricoOrdini,
  };
};

const handleResponseStoricoOrdiniProfili = (
  state: IUtilitiesState,
  {
    responseStoricoOrdiniProfili,
  }: { responseStoricoOrdiniProfili: IResponseStoricoOrdiniProfili | null }
): IUtilitiesState => {
  return {
    ...state,
    responseStoricoOrdiniProfili,
  };
};

const handleResponseStoricoOrdiniPartner = (
  state: IUtilitiesState,
  {
    responseStoricoOrdiniPartner,
  }: { responseStoricoOrdiniPartner: IResponseStoricoOrdiniPartner | null }
): IUtilitiesState => {
  return {
    ...state,
    responseStoricoOrdiniPartner,
  };
};

const handleResponseCreazioneOrdine = (
  state: IUtilitiesState,
  {
    responseCreazioneOrdine,
  }: { responseCreazioneOrdine: ResponseCreazioneOrdine | null }
): IUtilitiesState => {
  return {
    ...state,
    responseCreazioneOrdine,
  };
};

const handleResponseListFrazionario = (
  state: IUtilitiesState,
  {
    responseListFrazionario,
  }: { responseListFrazionario: IResponseOrdiniApprovvigionamento | null }
): IUtilitiesState => {
  return {
    ...state,
    responseListFrazionario,
  };
};

const handleResponsePinRecovery = (
  state: IUtilitiesState,
  {
    responsePinRecovery,
  }: { responsePinRecovery: IResponsePinRecovery | null }
): IUtilitiesState => {
  return {
    ...state,
    responsePinRecovery,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_UTILITY_LDV_SUCCESS, handleSaveUtilityLdv),
  on(RETRIEVE_GESTIONE_UTENZE_SUCCESS, handleGestioneUtenze),
  on(CREATE_UTENZA_SUCCESS, handleCreazioneUtenza),
  on(UPLOAD_DOCUMENT_LDV_SUCCESS, handleDocumentLdv),
  on(RETRIEVE_LISTA_RETE_TERZE_SUCCESS, handleListaReteTerze),
  on(RETRIEVE_RETE_TERZA_LIST_SUCCESS, handleReteTerzaList),
  on(RETRIEVE_COMPENSI_RETE_SUCCESS, handleResponseCompensiRete),
  on(RETRIEVE_COMPENSI_RETE_POST_SUCCESS, handleResponseCompensiRetePost),
  on(
    RETRIEVE_CONFIGURAZIONE_BOXLESS_SUCCESS,
    handleResponseConfigurazioneBoxless
  ),
  on(
    RETRIEVE_CONFIGURAZIONE_BOXLESS_POST_SUCCESS,
    handleResponseConfigurazioneBoxlessPost
  ),
  on(RETRIEVE_NEARLIST_UFF_POSTALE_SUCCESS, handleResponseFrazionarioList),
  on(SEARCH_LISTA_RECAPITO_SUCCESS, handleSearchStrutturaRecapito),
  on(RETRIEVE_GO_SUCCESS, handleResponseGo),
  on(RETRIEVE_RAM_GO_SUCCESS, handleResponseRamGo),
  on(RETRIEVE_CD_GO_SUCCESS, handleResponseCdGo),
  on(RETRIEVE_FRAZ_SUCCESS, handleResponseFraz),
  on(RETRIEVE_RECAPITO_SUCCESS, handleResponseRecapito),
  on(
    RETRIEVE_LISTA_CATALOGO_MATERIALE_SUCCESS,
    handleResponseListaCatalogoMateriale
  ),
  on(RETRIEVE_LISTA_CLUSTER_SUCCESS, handleResponseListaCluster),
  on(
    RETRIEVE_CONFIGURAZIONE_APPROVIGIONAMENTO_SUCCESS,
    handleResponseConfigurazioneApprovvigionamento
  ),
  on(RETRIEVE_REGOLE_ORDINE_SUCCESS, handleResponseRegoleOrdine),
  on(RETRIEVE_ORDER_HISTORY_SUCCESS, handleResponseStoricoOrdini),
  on(
    RETRIEVE_STORICO_ORDINI_PROFILI_SUCCESS,
    handleResponseStoricoOrdiniProfili
  ),
  on(
    RETRIEVE_STORICO_ORDINI_PARTNER_SUCCESS,
    handleResponseStoricoOrdiniPartner
  ),
  on(RETRIEVE_CREATE_ORDER_SUCCESS, handleResponseCreazioneOrdine),
  on(RETRIVE_LISTA_FRAZIONARIO_SUCCESS, handleResponseListFrazionario),
  on(RESET_UTILITY_STORE, handleResetUtilityStore),
  on(RETRIEVE_PIN_RECOVERY_SUCCESS, handleResponsePinRecovery)
);

export const utilitiesReducer = (
  state: IUtilitiesState | undefined,
  action: Action
): IUtilitiesState => reducer(state, action);
